import { memo, type ComponentProps, type FC } from 'react';

import type { FieldRenderProps } from '@/js/libs/final-form/index.ts';

import { Toggle } from './index.tsx';

type FieldType = FieldRenderProps<boolean, HTMLInputElement>;

type ToggleFieldProps = FieldType & Omit<ComponentProps<typeof Toggle>, 'checked' | 'onChange'>;

export const ToggleField: FC<ToggleFieldProps> = memo(function ToggleField(props) {
  const {
    input: { value, ...input },
    meta: _meta,
    dataTestId,
    ...other
  } = props;

  return (
    <Toggle {...input} {...other} checked={!!value} dataTestId={dataTestId ? `${dataTestId}-checked-${!!value}` : `checked-${!!value}`} />
  );
});
